import { create } from 'zustand';

/**
 * A share-link token the app was opened with (a tapped `https://market.../share/<token>` link), waiting for a grown-up to add the pack.
 * Memory only, on purpose: a link left lying around must not survive a restart, and nothing is added until the add form is used.
 */
interface PendingShareStore {
  readonly token: string | null;
  set(token: string): void;
  clear(): void;
}

export const usePendingShareStore = create<PendingShareStore>()((set) => ({
  token: null,
  set: (token) => set({ token }),
  clear: () => set({ token: null }),
}));
